<div class="header">
  <mat-icon class="material-symbols-outlined feedback-icon"> comment</mat-icon>
  <div class="title">
    <span class="title-text subtitle-03"> {{ title | titlecase }}</span>
    @if (subTitle) {
      <span class="body-03 subtitle-text">{{ subTitle }}</span>
    }
  </div>

  @if (isEditAllowed || isDeleteAllowed) {
    <div class="menu-actions">
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        #trigger="matMenuTrigger"
      >
        <mat-icon class="material-symbols-outlined feedback-icon">
          more_vert
        </mat-icon>
        <mat-menu #menu="matMenu">
          <button
            *ngIf="isEditAllowed"
            mat-menu-item
            class="menu-item-button"
            (click)="editFeedback()"
          >
            <span class="subtitle-03"> Edit </span>
          </button>
          <button
            *ngIf="isDeleteAllowed"
            mat-menu-item
            class="menu-item-button"
            (click)="deleteFeedback($event, trigger)"
          >
            <span class="subtitle-03"> Delete </span>
          </button>
        </mat-menu>
      </button>
    </div>
  }
</div>

<div class="attributes-container">
  @if (comment) {
    <div class="attribute">
      <span
        #commentElement
        class="subtitle-03 feedback-comment"
        [class.show-full-comment]="showFullComment"
      >
        {{ comment }}
      </span>
      <a
        *ngIf="isCommentTruncated$ | async"
        class="subtitle-03 comment-toggle"
        href="javascript:void(0)"
        (click)="toggleShowFullComment()"
      >
        {{ showFullComment ? 'show less' : 'show more' }}
      </a>
    </div>
  }
  <div class="attribute">
    <span class="body-03">
      {{ timestamp | date: 'y-MMM-d' }}
    </span>
  </div>
</div>
